export default __webpack_public_path__ + "locales/de/Profile.json?hash=4684a47bbcce0f86c20bfd59fde27f4a";